import {
  // Currencies,
  Notifications,
} from '@orbitalgaming/games-frontend-library'
import { Currencies } from '../../../../helpers/currency/getCurrencySymbol'
import { useEffect } from 'react'
import floorFigure from '../floorFigure'
import { logger } from '../../../../helpers/logger/logger'

export default function useLogs(
  step: string,
  autoData: any,
  handleNotification: any,
  currency: string,
  resetAuto: any,
  prec: number,
) {
  useEffect(() => {
    switch (step) {
      case 'STOP_ON_NUMBER_OF_BETS':
        logger.log('STOP_ON_NUMBER_OF_BETS -', autoData.rollAmount)
        handleNotification(Notifications.onSelectedNumberOfBets)
        resetAuto()
        break
      case 'STOP_ON_lOSS':
        logger.log('STOP_ON_lOSS - ', autoData.stopOnLoss)
        handleNotification(
          Notifications.stoppedOnLoss +
            floorFigure(autoData.stopOnLoss, prec) +
            Currencies[currency].symbol,
        )
        resetAuto()
        break
      case 'STOP_ON_PROFIT':
        logger.log('STOP_ON_PROFIT - ', autoData.stopOnWin)
        handleNotification(
          Notifications.stoppedOnWin +
            floorFigure(autoData.stopOnWin, prec) +
            Currencies[currency].symbol,
        )
        resetAuto()
        break
      case 'STOP_ON_MAX_STAKE':
        logger.log('STOP_ON_MAX_STAKE - ', autoData.maxStake)
        handleNotification(
          Notifications.reachedMaxStake +
            floorFigure(autoData.maxStake, prec) +
            Currencies[currency].symbol,
        )
        resetAuto()
        break
      default:
        break
    }
  }, [step])
}
